import React from 'react';
import Header from '../components/Header';

export default function About() {
  return (
    <>
      <Header />
      <h1>About</h1>
    </>
  );
}
